<!-- eslint-disable -->
<template>
  <div :class="P_customClass" :style="C_buttonContainerStyle">
    <component :is="DV_componentType">{{P_customCss}}</component>
    <div v-show="C_isVisible" class="image-button-container">
      <a 
        @mousedown="eventMouseDown(P_buttonId, P_makeSingleEvent)"
        @mouseup="eventMouseRelease(P_buttonId, P_makeSingleEvent)"
        @click="eventMouseClick(P_buttonId, P_makeSingleEvent)"
        class="image-button image-button-sound"
        :class="{active: C_isActiveState}"
      ></a>
      {{P_buttonText}}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: ["P_buttonText", "P_buttonId", 'P_makeSingleEvent', 'P_customCss'],
  data () {
    return {}
  },
  mixins: [bi10GridComponent],
  computed: {
    C_buttonContainerStyle() {
      const CI = this
      const additionalStyles = {}

      additionalStyles['height'] = CI.P_buttonHeight || "100%"
      additionalStyles['width'] = CI.P_buttonWidth || "100%"

      return additionalStyles;
    }
  }
}
</script>

<style lang="less" scoped>
.image-button-container {
  width: 100%;
  height: 100%;
  color: var(--font-color1);
  font-weight: 500;
  .image-button {
    display: block;
    height: 100%;
    width: 100%; 
    background-position: center;
    background-repeat: no-repeat;
    background-size: 80%, 85%;
    &.image-button-sound {
      background-image: url(/dynamic/images/b1/NU_GUI/mic-on.png), url(/dynamic/images/b1/NU_GUI/black.png);
      &:active {
        background-image: url(/dynamic/images/b1/NU_GUI/mic-on.png), url(/dynamic/images/b1/NU_GUI/blue.png);
      }
       &.active {
        background-image: url(/dynamic/images/b1/NU_GUI/mic-off-red-line.png), url(/dynamic/images/b1/NU_GUI/red.png);
        &:active {
          background-image: url(/dynamic/images/b1/NU_GUI/mic-off-red-line.png), url(/dynamic/images/b1/NU_GUI/blue.png);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/NU_GUI/GPrivacyButton.vue